import _ from '../vendors/_';
import tweenFunctions from 'tween-functions';
import Ticker from './Ticker';
import Timeout = NodeJS.Timeout;

export interface TweenProps {
  start?: number,
  end?: number,
  duration?: number,
  delay?: number,
  easing?: string,
  onProgress?: Function,
  onStart?: Function,
  onComplete?: Function,
}

export default class Tween {
  get onProcess(): boolean {
    return this._onProcess;
  }

  _currentValue: number;
  _bindedUpdateHdl: Function;
  _easingFunc: Function;
  _p: TweenProps;
  _delayId: Timeout;
  _paused: boolean;
  _startTime: number;
  _elapsedTime: number;
  private _onProcess: boolean = false;

  constructor(defaultValue = 1) {
    this._currentValue = defaultValue;
    this._bindedUpdateHdl = this._updateHdl.bind(this);
  }

  it(props: TweenProps):this {
    this._p = _.assignIn({
      start: this._currentValue,
      end: 0,
      duration: 0,
      delay: 0,
      easing: 'easeInOutQuad',
      onProgress: null,
      onStart: null,
      onComplete: null,
    }, props);
    this._easingFunc = tweenFunctions[this._p.easing] || tweenFunctions.linear;

    this.stop();

    if (this._p.delay === 0) {
      this._start();
    } else {
      this._delayId = setTimeout(this._start.bind(this), this._p.delay);
    }
    return this;
  }

  tick() {
    this._updateHdl();
  }

  pause() {
    this._paused = true;
    this.stop();
    this._elapsedTime = new Date().getTime() - this._startTime;
  }

  resume() {
    if (!this._paused) return;
    this._paused = false;
    this._start(this._elapsedTime);
  }

  stop() {
    this._onProcess = false;
    clearTimeout(this._delayId);
    Ticker.off(Ticker.e.update, this._bindedUpdateHdl);
  }

  _start(elapsedTime: number = 0) {
    this._onProcess = true;
    this._startTime = Ticker.state.currentTime;
    if (elapsedTime) this._startTime -= elapsedTime;
    Ticker.on(Ticker.e.update, this._bindedUpdateHdl);
    this._updateHdl();
    this._p.onStart && this._p.onStart();
  }

  _updateHdl() {

    const currentTime: number = Math.min(Ticker.state.currentTime - this._startTime, this._p.duration);
    this._currentValue = (this._p.duration === 0) ? this._p.end : this._easingFunc(currentTime, this._p.start, this._p.end, this._p.duration);

    this._p.onProgress && this._p.onProgress(this._currentValue, this._p.duration === 0 ? 0 : currentTime / this._p.duration);

    if (currentTime >= this._p.duration || this._p.duration === 0) {
      //complete
      this.stop();
      this._p.onComplete && this._p.onComplete();
    }
  }
}
